export const getInitialStateFromSessionStorage = ( key: string, defaultState: any ) => {
    if ( typeof window === "undefined") return defaultState
    const stateStr = sessionStorage.getItem( key )
    return stateStr ?
        JSON.parse( stateStr ) :
        defaultState
}
